import React from "react";
import { ToolType } from "types";

import {
  File as FileIcon,
  Cube,
  Book,
  Cursor,
  Verified,
  Video,
  Globe,
  Policy,
} from "assets/icons";

export const getToolTypeIcon = (
  toolType: ToolType
): React.ComponentType<any> | null => {
  switch (toolType) {
    case ToolType.poster:
      return FileIcon;
    case ToolType.educationalMaterial:
      return Cube;
    case ToolType.leaflet:
      return Book;
    case ToolType.game:
      return Cursor;
    case ToolType.test:
      return Verified;
    case ToolType.video:
      return Video;
    case ToolType.website:
      return Globe;
    case ToolType.policy:
      return Policy;
    default:
      return null;
  }
};
